import create from 'zustand';
import { DomainUser, OrgRole } from '../dto/user/User';

interface StoreProps {
	isLoggingIn: boolean;
	setIsLoggingIn: (isLoggingIn: boolean) => void;
	domainUser: DomainUser | null;
	orgRoles: OrgRole[] | null;
	domainRoles: string[] | null;
	setDomainUser: (domainUser: DomainUser) => void;
	hasRole: (role: string) => boolean;
	hasOneOfRoles: (roles: string[]) => boolean;
	getOrgName: (id: string) => string | undefined;
	isAuthorized: () => boolean;
}

const useAuthStore = create<StoreProps>((set, get) => ({
  isLoggingIn: true,
  setIsLoggingIn: (isLoggingIn: boolean) =>
    set((state) => ({ ...state, isLoggingIn: isLoggingIn })),
  domainUser: null,
  orgRoles: null,
  domainRoles: null,
  setDomainUser: (domainUser: DomainUser) =>
    set((state) => {
      return {
        ...state,
        domainUser,
        orgRoles: domainUser?.orgRoles,
        domainRoles: (domainUser?.orgRoles ?? []).map((role) => role.role)
      };
    }),
  hasRole: (role: string) => {
    return Boolean(get().domainRoles !== null && get().domainRoles?.find((r) => r === role));
  },
  hasOneOfRoles: (roles: string[]) => {
    return Boolean(
      get().domainRoles !== null && roles.every((r) => get().domainRoles?.includes(r))
    );
  },
  getOrgName: (orgId: string) => {
    return get().orgRoles?.find((role) => role.organizationId === orgId)?.orgName;
  },
  isAuthorized: () => {
    const { domainRoles } = get();

    return (domainRoles && domainRoles.some((x) => x === 'Portal Requester')) || false;
  }
}));

export { useAuthStore as default };
